module.exports = __webpack_public_path__ + "img/gygfzrrlwfzzsfpkjgzdtz.171a2227.jpg";